import { RootState } from 'store/root-reducer';
import { WimOperationalQualityI } from '../types/platforms';

export const fileIsLoading = (state: RootState): boolean => state.wim.wimOperationalQuality.isLoading;
export const getWimOperationalQuality = (state: RootState) => state.wim.wimOperationalQuality;
